import React from 'react'
import clsx from 'classnames'
import { useNavigate } from 'react-router'
import { Arrow } from 'components/Utility/Arrow/Arrow'
import styles from './Back.module.scss'

type BackProps = {
  className?: string,
  /** Defaults to going one step back in history */
  onClick?: () => void,
}

export const Back: React.FC<BackProps> = (props) => {
  const { className, onClick } = props
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      navigate(-1)
    }
  }

  return (
    <div className={clsx([styles.link, className])} onClick={handleClick}>
      <Arrow isDark isSmall direction={'left'} className={styles.arrow} />
      <div className={styles.text}>Назад</div>
    </div>
  )
}
